import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import { setWatchedEpisode } from '../../../assets/scripts/modules/localstorage.js'
import applyMappingsToClone from '../../../assets/scripts/utilities/apply-mappings-to-clone.js'
import insertScript from '../../../assets/scripts/utilities/insert-script.js'

const isReducedMotion = !!(window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true)
let timerTimeout
const nextTimerDelay = 15 * 1000

class EpisodeOverlayComponent extends Component {
  init() {
    this.closeButton = this.element.querySelector('.button--close')
    this.closeButton?.addEventListener('click', event => this.closeOverlay(event))

    this.outroTemplate = this.element.querySelector('.episode-overlay__outro-template')
    this.outroContainer = this.element.querySelector('.episode-overlay__outro')

    if (!this.outroTemplate || !this.outroContainer) {
      return
    }

    this.nextAvailableTitle = this.element.getAttribute('data-next-available-title') || ''
    this.nextUnavailableTitle = this.element.getAttribute('data-next-unavailable-title') || ''
    this.state = 'episode'
    this.isLastStep = false

    window.addEventListener('fetch-data', event => this.onFetchData(event))
    this.element.reinitAfterFetch = () => this.onFetchData({ detail: this.data })
    window.addEventListener('episode-overlay', event => this.onOpenEpisode(event.detail || {}))
    //window.addEventListener('popstate', () => this.handlePopState())

    // FIXME: This breaks episode scrolling on hero page -EKL
    //window.history.replaceState(null, '', window.location.pathname)

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' || event.keyCode === 'Escape') {
        window.clearTimeout(timerTimeout)
        this.nextButton?.classList.remove('button--timer-started')
      }
    })
  }

  onFetchData(event) {
    if (!event.detail) {
      return
    }

    this.data = { ...event.detail }

    const orderMap = new Map((this.data.character_order || []).map((id, index) => [id, index]))

    this.characters = this.data.characters?.length ? [...this.data.characters] : []
    this.characters.sort((a, b) => (orderMap.get(a.id) ?? Infinity) - (orderMap.get(b.id) ?? Infinity)) // Sort characters based on order

    this.episodes = this.data.episodes?.length ? [...this.data.episodes].sort((a, b) => a.id - b.id) : []

    this.checkHash()
  }

  checkHash() {
    if (!window.location.hash) {
      return
    }

    const hashId = window.location.hash.split('#')[1]

    if (this.episodes.find(episode => episode.id === hashId)) {
      this.onOpenEpisode({ episodeId: hashId })
    }
  }

  async onOpenEpisode(data = {}) {
    const { episodeId } = data

    if (!episodeId || !this.episodes.length) {
      return
    }

    const episode = this.episodes.find(episode => episode.id === episodeId)

    if (!episode) {
      return
    }

    this.toState('episode')
    this.element.classList.add('episode-overlay--loading')

    this.episode = episode

    const [, characterId] = window.location.pathname.match(/^\/([\w-]+)/) ?? []
    this.characterId = characterId

    if (!characterId) {
      console.error('No characterId found in pathname')
    }

    if (episode.story?.type === 'micrio') {
      this.isLastStep = false
      await this.showMicrioEpisode(episode)
    } else if (episode.story?.type === 'video') {
      await this.showVideoEpisode(episode)
    }

    if (window.location.hash !== episodeId) {
      this.oldHash = window.location.hash
      window.location.hash = episodeId
    }
  }

  handlePopState() {
    if (!window.location.pathname.match(/\/[\w-]+\/?/)) {
      return
    }

    // Handle the state change when the back button is pressed
    const episodeId = window.location.hash.substring(1)

    if (episodeId) {
      this.onOpenEpisode({ episodeId })
    } else {
      this.closeOverlay()
    }
  }

  async showMicrioEpisode(episode) {
    // episode.story is type {type: 'video', url: string}|{type: 'micrio', id: string}
    const id = episode.story.id

    if (!id) {
      return
    }

    if (this.embed) {
      this.removeEmbed()
    }

    await insertScript('micrio-script', 'https://b.micr.io/micrio-5.0.min.js')

    if (!document.getElementById(id)) {
      this.embed = document.createElement('micr-io')
      this.embed.id = id
    } else {
      this.embed = document.getElementById(id)
    }

    this.embed.lang = 'nl'

    this.setMicrioSettings()

    this.embed.addEventListener('load', this.onMicrioLoad)
    this.embed.addEventListener('pre-data', this.onMicrioPreData)
    this.embed.addEventListener('marker-opened', this.onMicrioMarkerOpened)
    this.embed.addEventListener('tour-step', this.onMicrioTourStep)
    this.embed.addEventListener('tour-stop', this.onContentEnded)
    this.embed.addEventListener('tour-ended', this.onContentEnded)

    this.element.appendChild(this.embed)
    this.element.removeAttribute('hidden')
    document.documentElement.classList.add('prevent-scrolling')
  }

  onMicrioLoad = event => {
    event.detail.settings.update(s => ({
      ...s,
      _markers: { ...s._markers, tourControlsInPopup: true, canMinimizePopup: false, popupAnimation: { duration: 500 } },
      ui: {
        ...s.ui,
        icons: {
          ...s.ui.icons,
          close: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"> <path d="m8.401 16.333-.734-.727L11.266 12 7.667 8.42l.734-.728L12 11.29l3.574-3.597.734.727L12.709 12l3.599 3.606-.734.727L12 12.737z"/> </svg>`,
          next: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"> <path d="M17.079 12.5H5v-1h12.079l-5.792-5.792L12 5l7 7-7 7-.713-.708z"/> </svg>`,
          prev: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"> <path d="m6.921 12.5 5.793 5.792L12 19l-7-7 7-7 .714.708L6.92 11.5H19v1z"/> </svg>`,
          // play: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#ef5c00" stroke-width="0" viewBox="0 0 32 32"> <path d="m21.5 16-11 7V9z"/> </svg>`
          // pause // subtitles // subtitlesOff // muted // unmuted
        },
      },
    }))
  }

  onMicrioPreData = event => {
    const firstTour = event.detail[this.embed.id]?.markerTours?.[0]

    if (firstTour) {
      this.micrioTourType = firstTour.isSerialTour ? 'serial' : 'marker'
      firstTour.cannotClose = true

      event.detail[this.embed.id]?.markers.forEach(m => {
        const content = Object.values(m.i18n)[0]
        content.title = content.title.replace(/ \d+\/\d+/, '')
      })

      this.embed.classList.add(firstTour.isSerialTour ? 'micrio--serial-tour' : 'micrio--marker-tour')

      if (firstTour.isSerialTour) {
        this.element.classList.add('episode-overlay--loading')
      }
    }

    this.embed.$current.settings.update(s => ({ ...s, start: firstTour ? { type: 'markerTour', id: firstTour.id } : s.start }))
  }

  onMicrioTourStep = event => {
    this.element.classList.remove('episode-overlay--loading')
    this.isLastStep = event.detail.currentStep === event.detail.steps.length - 1
  }

  onMicrioMarkerOpened = () => {
    if (this.micrioTourType !== 'marker') {
      return
    }

    setTimeout(() => {
      if (this.isLastStep) {
        const buttonContainer = document.querySelector('aside.micrio-marker-popup')
        const tourEndButton = document.createElement('button')
        const span = document.createElement('span')

        span.textContent = 'Volgende'
        span.classList.add('button__span')
        tourEndButton.classList.add('button', 'button--secondary', 'button--tour-end')
        tourEndButton.onclick = this.onContentEnded
        tourEndButton.appendChild(span)
        buttonContainer?.appendChild(tourEndButton)
      } else {
        document.querySelector('.button--tour-end')?.remove()
      }
    }, 500)
  }

  async showVideoEpisode(episode) {
    const videoUrl = episode.story.url

    if (!videoUrl) {
      return
    }

    if (this.embed) {
      this.removeEmbed()
    }

    // create a video element and add it to the overlay, showing it fullscreen
    this.embed = document.createElement('video')

    this.embed.src = videoUrl
    this.embed.controls = true
    this.embed.autoplay = true
    this.embed.muted = false
    this.embed.playsinline = true

    this.embed.addEventListener('ended', this.onContentEnded)

    this.element.appendChild(this.embed)
    this.element.removeAttribute('hidden')

    this.element.classList.remove('episode-overlay--loading')
    document.documentElement.classList.add('prevent-scrolling')
  }

  closeOverlay(event) {
    event?.preventDefault()

    if (this.oldHash === `#${this.episode.id}`) {
      // This bugs out the carousel
      //window.location.hash = `#episode-card-${this.episode.id}`
    } else {
      window.location.hash = this.oldHash
      this.oldHash = null
    }

    if (this.embed) {
      this.removeEmbed()
    }

    this.element.setAttribute('hidden', '')
    this.element.classList.remove('episode-overlay--loading')
    document.documentElement.classList.remove('prevent-scrolling')

    setTimeout(() => {
      this.toState('episode')
    }, 100)
  }

  removeEmbed() {
    if (!this.embed) {
      return
    }

    // micrio events
    this.embed.removeEventListener('load', this.onMicrioLoad)
    this.embed.removeEventListener('pre-data', this.onMicrioPreData)
    this.embed.removeEventListener('marker-opened', this.onMicrioMarkerOpened)
    this.embed.removeEventListener('tour-step', this.onMicrioTourStep)
    this.embed.removeEventListener('tour-stop', this.onContentEnded)
    this.embed.removeEventListener('tour-ended', this.onContentEnded)

    if (this.episode.story?.type === 'micrio') {
      this.embed.close?.(this.embed.$current) // close current micrio image/tour!!
      this.embed.destroy?.()
    }

    this.embed.removeEventListener('ended', this.onContentEnded) // video ended event
    this.embed.remove()
    this.embed = null
  }

  setMicrioSettings() {
    this.embed.dataset.lazyload = false
    this.embed.dataset.camspeed = isReducedMotion ? '0' : '1'
    this.embed.dataset.dragging = false
    this.embed.dataset.events = false
    this.embed.dataset.toolbar = false
    this.embed.dataset.keys = false
    this.embed.dataset.showInfo = false
    this.embed.dataset.zooming = false
    this.embed.dataset.social = false
    this.embed.dataset.minimap = false
    this.embed.dataset.logo = false
    this.embed.dataset.fullscreen = false
    this.embed.dataset.controls = false
    this.embed.dataset.coverlimit = true
  }

  onContentEnded = () => {
    if (this.episode) {
      this.episode.watched = true
      setWatchedEpisode(this.episode)
      window.dispatchEvent(new CustomEvent('episode-watched', { detail: this.episode }))
    }

    this.toState('outro')
  }

  toState = state => {
    if (this.state === state) {
      return
    }

    this.outroContainer?.scrollTo({ top: 0 })
    this.state = state

    if (state === 'episode') {
      this.emptyOutroScreen()
    } else if (state === 'outro') {
      this.removeEmbed()
      this.populateOutroScreen()
    }
  }

  populateOutroScreen() {
    if (!this.episode || !this.episodes.length) {
      return
    }

    const character = this.characters.find(character => character.id === this.characterId)

    if (!character) {
      return
    }

    const characterEpisodes = character?.episodes.map(episodeId => this.episodes.find(episode => episode.id === episodeId))
    const nextEpisode = characterEpisodes?.[characterEpisodes.indexOf(this.episode) + 1]

    const clone = this.outroTemplate.content.cloneNode(true)

    const mappings = [
      { selector: '.episode-overlay__image', values: { src: !nextEpisode ? character.image : nextEpisode.is_released ? nextEpisode.image : '/static/media/placeholders/episode.unreleased.jpg', classList: ['episode-overlay__image--blackwhite'] } },
      { selector: '.episode-overlay__pretitle', values: { textContent: !nextEpisode ? null : nextEpisode.is_released ? this.nextAvailableTitle : this.nextUnavailableTitle } },
      { selector: '.episode-overlay__title', values: { textContent: nextEpisode?.title ?? `Einde van ${character.title}'s verhaal` } },
      { selector: '.episode-overlay__description', values: { textContent: !nextEpisode || nextEpisode.is_released ? null : nextEpisode.description } },
      { selector: '.episode-overlay__social', values: { attributes: nextEpisode?.is_released ? { hidden: 'hidden' } : {} } },
      { selector: '.episode-overlay__social-title', values: { textContent: !nextEpisode ? 'Blijf op de hoogte van de nieuwe verhalen' : 'Blijf op de hoogte van de nieuwe aflevering' } },
      { selector: '.button--timer', values: { attributes: nextEpisode?.is_released ? {} : { hidden: 'hidden' } } },
    ]

    applyMappingsToClone(mappings, clone)

    this.nextButton = clone.querySelector('.button--next')

    if (nextEpisode) {
      this.nextButton?.addEventListener('click', () => this.onOpenEpisode({ episodeId: nextEpisode.id }))
    } else {
      this.nextButton?.remove()
    }

    this.outroContainer.appendChild(clone)

    const carousel = this.outroContainer.querySelector('.character-card-carousel')
    carousel?.setAttribute('data-exclude-ids', character.id)

    if (carousel) {
      window.dispatchEvent(new CustomEvent('reinit-character-card-carousel', { detail: carousel }))
    }

    this.outroContainer.removeAttribute('hidden')

    if (nextEpisode?.is_released) {
      window.clearTimeout(timerTimeout)
      timerTimeout = window.setTimeout(() => this.nextButton?.click(), nextTimerDelay)
      this.nextButton?.classList.add('button--timer-started')
    }
  }

  emptyOutroScreen() {
    this.outroContainer?.setAttribute('hidden', '')
    this.nextButton = null
    clearTimeout(timerTimeout)

    if (this.outroContainer && this.outroContainer.children) {
      ;[...this.outroContainer.children].forEach(child => child.remove())
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'episode-overlay', EpisodeOverlayComponent))
